function isSameSignSelected({ decimalSeparator, thousandsSeparator }) {
  return decimalSeparator === thousandsSeparator;
}

export default {
  isSameSignSelected,
};
